<template>
  <div>
    <Nav />
    <div class="groupInfo_box">
      <el-row>
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="24"
          :xl="24"
          :offset="1"
          class="groupInfo_title flex pageTitle"
          style="padding:60px 0px 30px;"
        >
          <span>Recommended colleagues：({{tableData.length}} People)</span>
          <div>
            <el-button @click="addColleague" type="primary" :style="btnAllStyle">Add colleagues</el-button>
            <el-button @click="downList" type="primary" :style="btnAllStyle" :disabled="tableData.length<=0">Download</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :offset="1">
          <el-table style="width:100%" :data="tableData" v-show="tableDisplay">
            <el-table-column label="Name" prop="PsjName"></el-table-column>
            <el-table-column label="Dept" prop="PsjDept"></el-table-column>
            <el-table-column label="Rank" prop="PsjRank"></el-table-column>
            <el-table-column label="Mobile" prop="PsjMobile"></el-table-column>
            <el-table-column label="Tel" prop="PsjTel"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import api from '../api'
import Nav from '../components/Nav'
export default {
  name: 'HelpRegister',
  components: {
    Nav
  },
  data() {
    return {
      tableData: [],
      ExhID: sessionStorage.getItem('ExhID'),
      btnAllStyle: sessionStorage.getItem('btnAll') ? JSON.parse(sessionStorage.getItem('btnAll')).styles : {},
      tableDisplay: true
    }
  },
  mounted() {
    // 清空之前的回显
    sessionStorage.setItem('helpDataInfo', '')
    sessionStorage.setItem('helpAnswerObj', '')
    sessionStorage.setItem('helpDataAnswer', '')
    // 获取协助注册成员列表
    this.getHelpList()
    // 获取局部可配置项接口
    this.getPageConfig()
  },
  methods: {
    addColleague: function() {
      // 获取被协助人token
      api.getEFWapToken({}).then(res => {
        if (res.data.status === 'OK') {
          sessionStorage.setItem('helptoken', res.data.WapToken)
          this.$router.push('addEmployee')
        } else {
          this.$alert(res.data.ErrorEMsg)
        }
      })
    },
    downList: function() {
		alert(1234)
	  var params = {
		ExhID: this.ExhID,
		PsnID: sessionStorage.getItem('PsnID')
	  }
      location.href = api.assisedMembersExport(params)
    },

    getHelpList: function() {
      var param = {
        ExhID: this.ExhID,
        PsnID: sessionStorage.getItem('PsnID'),
        Language: 'en'
      }
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      api.assisedMembers(param).then(res => {
        loading.close()

        if (res.data.status === 'OK') {
          if((res.data.Data).length === 0){
            this.tableDisplay = false
          }
          this.tableData = res.data.Data
        } else {
          this.$alert(res.data.ErrorEMsg)
        }
      })
    },
    getPageConfig: function() {
      var param = {
        ExhID: this.ExhID,
        RegistType: 'pc',
        page: 'ColleaguesList'
      }
      api.getPage(param).then(res => {
        if (res.data.status === 'OK') {
          console.log(res)
        } else {
          this.$alert(res.data.ErrorEMsg)
        }
      })
    }
  }
}
</script>
<style>
.groupInfo_box {
  width: 100%;
  max-width: 100%;
  background: #fff;
  min-height: calc(60vh);
  box-sizing: border-box;
  padding: 15px;
}
.groupInfo_box .el-col-offset-1 {
  margin-left: 0;
}
.groupInfo_title {
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/pages/HelpRegister.vue